import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";
import { resolveLiveTheme } from "@/lib/themeSchedule";
import { ssrMemoSwr } from "@/lib/ssrMemo";

/** Public theme fields only, resolved with anonymous read permissions. */
export const getInitialSiteTheme = createServerFn({ method: "GET" }).handler(async () => {
  const url = process.env['SUPABASE_URL'] || import.meta.env['VITE_SUPABASE_URL'];
  const key = process.env['SUPABASE_PUBLISHABLE_KEY'] || import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'];
  if (!url || !key) return null;
  const client = createClient(url, key, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
    global: {
      fetch: (input, init) => {
        const headers = new Headers(init?.headers);
        if (key.startsWith("sb_publishable_") && headers.get("Authorization") === `Bearer ${key}`) headers.delete("Authorization");
        headers.set("apikey", key);
        return fetch(input, { ...init, headers, signal: AbortSignal.timeout(5000) });
      },
    },
  });
  try {
    // Public selection only; never cache HTML or authenticated data.
    return await ssrMemoSwr("site-theme:public", 15_000, 10 * 60_000, () => resolveLiveTheme(client));
  } catch (error) {
    console.error(error);
    return null;
  }
});